export default "__VITE_ASSET__BWpDWm4T__"